module.exports = __webpack_public_path__ + "img/1280x720-Classroom.5728f3a1.jpg";